import { render, staticRenderFns } from "./WizardNav.vue?vue&type=template&id=0cf4c74c&"
import script from "./WizardNav.vue?vue&type=script&lang=js&"
export * from "./WizardNav.vue?vue&type=script&lang=js&"
import style0 from "./WizardNav.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports